module.exports = __webpack_public_path__ + "img/Content.708c0295.png";